export default __webpack_public_path__ + "static/media/FiraSans-Light.7ece67e1.ttf";